import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useStep } from "usehooks-ts";
import {
  getStepsDesktop,
  getStepsMobile,
  steps as stepsLabels,
  getProjectData,
  defaultValuesOfProjectData
} from "./helper";
import ProjectSection from "./project-detail";
import AgendaSection from "./agenda-section";
import ConfirmationSection from "./confirmation-section";
import { useIsMobile } from "../../utils/hooks/useIsMobile";
import { ProjectData, TAcceptInvitationFormProps } from "./type";
import { useFullPageLoading } from "../../atoms/full-page-loading/loadingContext";
import { useBoolean } from "../../utils/hooks/useBoolean";
import ContactUsDialog from "../../atoms/calls/calls-card/ContactUsDialog";
import { Button, Typography } from "@mui/material";

export default function AcceptInvitationForm({ id, isInvitationAccepted, share_agenda, userId, projectId, peId, expertId }: TAcceptInvitationFormProps) {
  const isMobile = useIsMobile()
  const {
    value: isContactUsOpen,
    setFalse: CloseContactUs,
    setTrue: openContactUs,
  } = useBoolean();
  const { value: isAccpetInvitationApiSuccessful, setValue: setAccpetInvitationApiSuccessful } = useBoolean()
  const [projectData, setProjectData] = React.useState<ProjectData>(defaultValuesOfProjectData);
  const { setLoading } = useFullPageLoading();
  const steps = isMobile ? getStepsMobile(share_agenda, !isInvitationAccepted) : getStepsDesktop(share_agenda, !isInvitationAccepted);
  const [activeStep, helpers] = useStep(steps.length);

  const { goToNextStep } = helpers;

  React.useEffect(() => {
    async function getData() {
      setLoading(true);
      const data = await getProjectData(projectId, expertId);
      if (data) {
        setProjectData(data);
      }
      setLoading(false);
    }

    getData();
  }, [userId]);

  return (
    <React.Fragment>

      <Box sx={{
        width: "100%", maxWidth: "1020px",
        mx: "auto",
        mt: { xs: "8px", md: "62px" },
        display: "flex",
        flexDirection: "column",
      }}>
        <Box display={'flex'} mr={2} alignSelf={'flex-end'}>
          <Button size="small" variant="text" sx={{ textTransform: 'none', gap: '5px' }} onClick={openContactUs}>
            <Typography fontWeight={500} >POC:</Typography>
            <Typography fontWeight={500}>{projectData?.account_manager_value.name}</Typography>
          </Button>
        </Box>
        <Box
          sx={{
            background: "white",
            borderRadius: "16px",
            padding: "1.5rem 1rem",
            boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)",
          }}
        >

          <Stepper sx={{ marginBottom: 2 }} activeStep={activeStep - 1}>
            {steps.map((label) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel
                    {...labelProps}
                    sx={{
                      fill: "#fff",
                      "& .MuiStepIcon-text": {
                        fill: "#FFF",
                      },
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>

          <React.Fragment>
            <Box sx={{ mb: 1, padding: "0 8px" }}>
              {steps[activeStep - 1] === stepsLabels.desktop.invitation || steps[activeStep - 1] === stepsLabels.mobile.invitation ? (
                <ProjectSection
                  invitationId={id}
                  projectId={projectId}
                  goToNextStep={goToNextStep}
                  projectData={projectData}
                />
              ) : null}
              {(steps[activeStep - 1] === stepsLabels.desktop.agenda || steps[activeStep - 1] === stepsLabels.mobile.agenda) && share_agenda ? (
                <AgendaSection
                  invitationId={id}
                  isInvitationAccepted={isInvitationAccepted || isAccpetInvitationApiSuccessful}
                  projectId={projectId}
                  expertId={expertId}
                  isAgenda={share_agenda}
                  peId={peId}
                  goToNextStep={goToNextStep}
                />
              ) : null}
              {(steps[activeStep - 1] === stepsLabels.desktop.confirmation || steps[activeStep - 1] === stepsLabels.mobile.confirmation) ? (
                <ConfirmationSection
                  invitationId={id}
                  isInvitationAccepted={isInvitationAccepted}
                  isAgenda={share_agenda}
                  goToNextStep={goToNextStep}
                  projectId={projectId}
                  expertId={expertId}
                  setAccpetInvitationApiSuccessful={setAccpetInvitationApiSuccessful}
                />
              ) : null}
            </Box>
            {isContactUsOpen && (
              <ContactUsDialog isOpen={isContactUsOpen} handleClose={CloseContactUs} name={projectData?.account_manager_value.name} email={projectData?.account_manager_value.email} phoneNumber={projectData.account_manager_value.mobile} />
            )}
          </React.Fragment>
        </Box>
      </Box>
    </React.Fragment>
  );
}

